import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Accordion,
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Row,
} from "react-bootstrap";
import Switch from "react-switch";

import "react-phone-input-2/lib/style.css";
// css
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";

import TableLayout from "../../../../components/TableLayout";
import { EditIcon } from "Assets/icons";
import { useAssignAssociatedTherapistMutation, useDeleteAssociatedTherapistMutation, useGetStaffAssociatedClientstListQuery, useGetStaffAssociatedTherapistListQuery, useGetStaffAssociatedTherapistListV2Query, useGetSupportStaffDetailQuery, useUpdateSupportStaffMutation, useUpdateSupportStaffStatusMutation } from "store/services/supportStaff";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { convertToMomentDate, dateFormat, successMessageToast, userFullName } from "helpers/common";
import moment from "moment";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import AddStaffClient from "components/Modals/AddStaffClientPop";
import { MANAGE_SUPPORT_STAFF_CLIENT_TASKS, MANAGE_SUPPORT_STAFF_LIST } from "config/paths";
import { CLIENT_PATH, CLIENT_TYPE } from "config/constants";
import { useGetSchoolDataQuery } from "store/services/schools";
import { Breadcrumbs, CommonSelect, CstmPagination, NoRecordFoundV2 } from "components/Common/Common";
import ErrorComponent from "components/shared/ErrorComponent";
import TableHeader from "components/shared/FormComponents/TableHeader";
import AssignStaffToTherapistPop from "components/Modals/AssignStaffToTherapist";
import { GroupsTable } from "./GroupsTable";
import ConsentCheckListsModal from "components/Modals/ConsentChecklistsModal";
import TableLayoutV2 from "components/TableLayoutV2";
import { debounce } from "lodash";

const SupportStaffDetails = () => {
  const { id: staffId } = useParams();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [clientCurrentPage, setClientCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [staffUpdateDetails, setStaffUpdateDetails] = useState(null);
  const [checked, setChecked] = useState(false)
  const { data, isLoading, isFetching } = useGetSupportStaffDetailQuery(staffId, { skip: !staffId });
  const staffDetails = data?.record;
  const associatedClients = data?.associatedClients?.clients || [];
  const [therapistFilter, setTherapistFilter] = useState({ search: "", status: "", page: 1, limit: pageSize })
  const [clientsFilter, setClientsFilter] = useState({ search: "", status: "", page: 1, limit: pageSize })
  const [therapistModal, setTherapistModal] = useState(false)
  const [newTherapist, setNewTherapist] = useState(null)


  // const { data: schoolData, isLoading: isSchoolLoading, isFetching: isSchoolFetching, isError: isSchoolError, } = useGetSchoolDataQuery(staffDetails?.staffDetail?.school[0], {
  //   skip: !staffDetails?.staffDetail?.school[0],
  // });
  const { data: therapistsList, isLoading: therapistsListLoading, isFetching: therapistsListFetching, isError: therapistListError } = useGetStaffAssociatedTherapistListV2Query({ id: staffId, ...therapistFilter })
  const therapistsTotalRecord = therapistsList?.totalRecords || 0;
  const therapistsTotalPages = Math.ceil(therapistsTotalRecord / pageSize);
  const { data: clientsList, isLoading: clientsListLoading, isFetching: clientsListFetching, isError: clientListError } = useGetStaffAssociatedClientstListQuery({ id: staffId, ...clientsFilter })
  const clientsTotalRecord = clientsList?.associatedClients?.totalRecords || 0;
  const clientsTotalPages = Math.ceil(clientsTotalRecord / pageSize);
  const [updateSupportStaff, { isLoading: updateLoading }] = useUpdateSupportStaffMutation();
  const [updateSupportStaffStatus, { isLoading: updateStatusLoading }] = useUpdateSupportStaffStatusMutation();
  // const [deleteTherapist, { isLoading: deleteTherapistLoading }] = useDeleteAssociatedTherapistMutation()
  const [assignToTherapist, { isLoading: assigntToTherapistLoading }] = useAssignAssociatedTherapistMutation()

  const column = [
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      component: (item, ind) => {
        return (<h6 className="m-0 fw-bold themeBlue text-capitalize">{item?.client?.client_detail?.lastname || "--"}</h6>
        )
      },
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue text-capitalize">{item?.client?.client_detail?.firstname || "--"}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "dob",
      isComponent: true,
      component: (item, ind) => (
        <>{convertToMomentDate(item?.client?.dob)}</>
      ),
    },
    {
      head: "Grade",
      accessor: "grade",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client?.grade || "-"}</>
      ),
    },
    {
      head: "Gender",
      accessor: "grade",
      isComponent: true,
      component: (item, ind) => (
        <p className="text-capitalize">{item?.client?.gender || "-"}</p>
      ),
    },
    // {
    //   head: "Action",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <>-</>
    //     <div className="ActnBtn d-flex align-items-center  gap-10">
    //       <div className="d-flex align-items-center gap-10">
    //         <Button
    //           style={{ minWidth: "unset " }}
    //           className="d-flex align-items-center justify-content-center commonBtn h-auto"
    //           onClick={() => navigate(MANAGE_SUPPORT_STAFF_CLIENT_TASKS?.replace(":staffId", staffId)?.replace(":clientId", item?.client_id))}
    //         >
    //           <span className="icn me-1">
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="16"
    //               height="11"
    //               viewBox="0 0 16 11"
    //               fill="none"
    //             >
    //               <path
    //                 d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
    //                 fill="white"
    //               />
    //             </svg>
    //           </span>
    //           View
    //         </Button>
    //       </div>
    //     </div >
    //   ),
    // },
  ];

  const therapistColumn = [
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue text-capitalize">{item?.creator?.lastname || "--"}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue text-capitalize">{item?.creator?.firstname || "--"}</h6>
      ),
    },
    {
      head: "Email",
      accessor: "email",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{item?.creator?.email || "--"}</h6>
      ),
    },
    {
      head: "Phone",
      accessor: "phone",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.creator?.phone || "-"}</>
      ),
    },
    // {
    //   head: "Action",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn d-flex align-items-center  gap-10">
    //       <div className="d-flex align-items-center gap-10">
    //         <Button
    //           style={{ minWidth: "unset " }}
    //           className="d-flex align-items-center justify-content-center commonBtn h-auto"
    //           // onClick={() => navigate(CLIENT_PATH[item?.associatedClient?.client_detail?.client_type]?.replace(":id", item?.client_id))}
    //           onClick={() => navigate(MANAGE_SUPPORT_STAFF_CLIENT_TASKS?.replace(":staffId", staffId)?.replace(":clientId", item?.client_id))}
    //         >
    //           <span className="icn me-1">
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="16"
    //               height="11"
    //               viewBox="0 0 16 11"
    //               fill="none"
    //             >
    //               <path
    //                 d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
    //                 fill="white"
    //               />
    //             </svg>
    //           </span>
    //           View
    //         </Button>
    //       </div>
    //     </div >
    //   ),
    // },
  ];



  // const clientsColumn = [
  //   {
  //     head: "Last Name",
  //     accessor: "lastname",
  //     isComponent: true,
  //     component: (item, ind) => (
  //       <h6 className="m-0 fw-bold themeBlue text-capitalize">{item?.associatedClient?.lastname || "--"}</h6>
  //     ),
  //   },
  //   {
  //     head: "First Name",
  //     accessor: "firstname",
  //     isComponent: true,
  //     component: (item, ind) => (
  //       <h6 className="m-0 fw-bold themeBlue text-capitalize">{item?.associatedClient?.firstname || "--"}</h6>
  //     ),
  //   },
  //   {
  //     head: "Email",
  //     accessor: "email",
  //     isComponent: true,
  //     component: (item, ind) => (
  //       <h6 className="m-0 fw-bold themeBlue text-capitalize">{item?.associatedClient?.email || "--"}</h6>
  //     ),
  //   },
  //   {
  //     head: "Phone",
  //     accessor: "phone",
  //     isComponent: true,
  //     component: (item, ind) => (
  //       <>{item?.associatedClient?.phone || "-"}</>
  //     ),
  //   },
  //   // {
  //   //   head: "Action",
  //   //   accessor: "",
  //   //   isComponent: true,
  //   //   component: (item) => (
  //   //     <div className="ActnBtn d-flex align-items-center  gap-10">
  //   //       <div className
  //     head: "Phone",
  //     accessor: "phone",
  //     isComponent: true,="d-flex align-items-center gap-10">
  //   //         <Button
  //   //           style={{ minWidth: "unset " }}
  //   //           className="d-flex align-items-center justify-content-center commonBtn h-auto"
  //   //           // onClick={() => navigate(CLIENT_PATH[item?.associatedClient?.client_detail?.client_type]?.replace(":id", item?.client_id))}
  //   //           onClick={() => navigate(MANAGE_SUPPORT_STAFF_CLIENT_TASKS?.replace(":staffId", staffId)?.replace(":clientId", item?.client_id))}
  //   //         >
  //   //           <span className="icn me-1">
  //   //             <svg
  //   //               xmlns="http://www.w3.org/2000/svg"
  //   //               width="16"
  //   //               height="11"
  //   //               viewBox="0 0 16 11"
  //   //               fill="none"
  //   //             >
  //   //               <path
  //   //                 d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
  //   //                 fill="white"
  //   //               />
  //   //             </svg>
  //   //           </span>
  //   //           View
  //   //         </Button>
  //   //       </div>
  //   //     </div >
  //   //   ),
  //   // },
  // ];

  const statusOptions = [
    {
      label: "Active",
      value: "active"
    },
    {
      label: "Inactive",
      value: "inactive"
    },
    {
      label: "Archived",
      value: "archived"
    },
  ];

  const handleUpdate = async () => {

    try {

      setShowModal(false);
      const result = await updateSupportStaffStatus({ data: staffUpdateDetails, staffId })
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) { console.error("Error updating staff details status") };
  };

  const handleClientPageChange = (page) => {
    window.scrollTo(0, 0);
    setClientsFilter((prev) => ({ ...prev, page }));
  };

  const handleTherapistsPageChange = (page) => {
    window.scrollTo(0, 0);
    setTherapistFilter((prev) => ({ ...prev, page }));
  };

  const handleTherapistFilterChange = (key) => (value) => {
    setTherapistFilter((prev) => ({ ...prev, [key]: value, page: 1 }))
  }

  const resetTherapistFilter = () => {
    setTherapistFilter((prev) => ({ ...prev, search: "", status: "", page: 1, limit: pageSize }));
  };
  //     head: "Phone",
  //     accessor: "phone",
  //     isComponent: true,

  const handleClientFilterChange = (key) => (value) => {
    setClientsFilter((prev) => ({ ...prev, [key]: value, page: 1 }))
  }

  const resetClientFilter = () => {
    setClientsFilter((prev) => ({ ...prev, search: "", status: "", page: 1, limit: pageSize }));
  };

  const handleAssignToTherapist = async (values) => {
    const body = {
      staff_id: staffId,
      therapist_id: values?.therapist_id?.value
    }
    try {
      await assignToTherapist(body).unwrap()
      setTherapistModal(false)
    } catch (error) {
      console.error('Error ASsigning to therapist', error)
    }
  }

  // const handleDeleteAssociatedTherapist = async () => {
  //   setShowModal(false)
  //   try {
  //     await deleteTherapist({ id: currentTherapist?.id }).unwrap()
  //   } catch (error) {
  //     console.error("Error deleting therapist: ", error)
  //   }
  // }



  useEffect(() => {

    if (staffDetails) {

      const { firstname, lastname, phone, email, status, isLoginAllowed } = staffDetails;
      const { city_town, division, school, grade, description, client_type } = staffDetails?.staffDetail || {};
      setStaffUpdateDetails({ firstname, lastname, phone, email, description, city_town, client_type, division, school, grade, status, isLoginAllowed, associated_clients: associatedClients?.map(i => i?.client_id) });
    };
  }, [staffDetails]);

  const assignedSchools = useMemo(() => {
    if (!staffDetails?.school_support_staff?.length) {
      return [];
    }
    const map = {};
    staffDetails?.school_support_staff.forEach(item => {
      const divisionId = item.divisions.id;

      if (!map[divisionId]) {
        map[divisionId] = {
          divisionId,
          divisionTitle: item.divisions.title,
          schools: []
        };
      }

      map[divisionId].schools.push({
        id: item.schools.id,
        name: item.schools.name
      });
    });

    return Object.values(map);
  }, [staffDetails?.school_support_staff])

  const breadcrumbItems = [
    { label: "Support Staff Profiles", path: MANAGE_SUPPORT_STAFF_LIST },
    { label: userFullName(staffDetails) || "Staff Details" },
  ];

  const handleTherapistSearchChange = useCallback(debounce((value) => {
    setTherapistFilter((prev) => ({ ...prev, page: 1 }));
    handleTherapistFilterChange("search")(value);
  }, 500), [handleTherapistFilterChange, 500]);

  const handleClientSearchChange = useCallback(debounce((value) => {
    setClientsFilter((prev) => ({ ...prev, page: 1 }));
    handleClientFilterChange("search")(value);
  }, 500), [handleClientFilterChange, 500]);


  return (
    <>
      <AssignStaffToTherapistPop
        showPopup={therapistModal}
        setShowPopup={setTherapistModal}
        handleSubmit={handleAssignToTherapist}
        setTherapist={setNewTherapist}
        isLoading={assigntToTherapistLoading}
        discipline={{ label: staffDetails?.staffDetail?.staff_discipline_Assigned?.name, value: staffDetails?.staffDetail?.staff_discipline_Assigned?.id }}
      />

      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleUpdate}
        type="update"
      />

      <AddStaffClient
        show={showAddModal}
        setShow={setShowAddModal}
        staffDetail={staffUpdateDetails}
        staffId={staffId}
      />
      <section className=" position-relative">
        {isLoading ? <LoadingIndicator /> : <Container fluid={true}>


          <Row style={{ borderBottom: "1px solid #dee2e6" }}>
            {(updateLoading || isLoading || isFetching || updateStatusLoading) ? <LoadingOverlay /> : null}
            <Row className="pt-3">
              <Col lg="7">
                <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
              </Col>
              <Col lg="5">

              </Col>
            </Row>

            <div style={{ marginTop: data?.status == 'active' ? "-10px" : '20px' }}>
              <p>
                <div className="d-flex align-items-end gap-2 proxima-regular">
                  <Row className="w-100 align-items-end">
                    <Col lg='7'>
                      <div className="d-flex gap-3 align-items-end">
                        <p className="twenty proxima-regular mb-0 d-flex gap-2" style={{ color: "#000", fontSize: "20px" }}>
                          {staffDetails?.status != 'active' && <div className="text-capitalize">{`${staffDetails?.status}:`}</div>}{" "}{userFullName(staffDetails)}
                        </p>
                        <div style={{ width: "25%" }} className="reports-v2 classroom-conslutation">
                          <div className="w-100 align-items-center gap-3">
                            {/* <label className="discharge-screen-label mb-0">School</label> */}
                            <CommonSelect
                              placeholder={"Choose one..."}
                              option={statusOptions?.filter((item) => item?.value && item?.value != staffDetails?.status)}
                              // onChange={(e) => handleUpdateStatus(e, e)}
                              onChange={e => {
                                setStaffUpdateDetails({ status: e?.value });
                                setShowModal(true);
                              }}
                              // value={clientStatus}
                              value={statusOptions?.find(x => x.value === staffDetails?.status)}
                              // onInputChange={(val) => handleSearch(val)}
                              isFilterV2
                              // isClearable
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  width: "100%",
                                }),
                              }}
                            // isLoading={schoolsLoading}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col lg='5'>
                      <div className="d-flex align-items-end justify-content-end gap-3">

                        <div style={{ display: "flex", gap: "10px" }}>
                          {
                            <div className="cursor-pointer mb-2" onClick={() => setClientExpiryModal(true)} style={{ marginLeft: "auto", width: "236px", borderRadius: "4px", border: "1px solid #8F8F8F", padding: "10px 12px" }}>
                              <Row className="mb-1">
                                <Col lg='6'>
                                  <h3 className="black ten proxima-regular" style={{ fontWeight: "600" }}>ACCOUNT STATUS</h3>
                                </Col>
                                <Col lg='6'>
                                  <h3 className="black ten proxima-regular text-start" style={{ fontWeight: "600" }}>DATE CREATED</h3>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg='6'>
                                  <h2 className="forteen mb-0 proxima-regular text-capitalize" style={{ color: staffDetails?.status == 'active' && "#55A215", fontStyle: ["archived", "discharged"]?.includes(staffDetails?.status) && "italic" }}>{staffDetails?.status}</h2>
                                </Col>
                                <Col lg='6'>
                                  <h2 className="black mb-0 forteen  text-start">{staffDetails?.createdAt ? moment(staffDetails?.createdAt).format("MMM DD, YYYY") : "--"}</h2>
                                </Col>
                              </Row>
                            </div>
                          }
                          {/* <div style={{ width: "148px" }} onClick={() => { if (!isDischarged && !isInactive) setAttendanceModal(true) }}>
                              <h2 style={{
                                border: "1px solid #93278F",
                                padding: "10px 12px",
                                cursor: (!isDischarged && !isInactive) ? "pointer" : "not-allowed",
                                opacity: (!isDischarged && !isInactive) ? 1 : 0.5,
                                pointerEvents: (!isDischarged && !isInactive) ? "auto" : "none"
                              }} className="themePurple mb-0 cursor-pointer proxima-regular forteen text-center">Track Attendance</h2>
                            </div> */}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </p>
            </div>


            <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
              <div className="d-flex align-items-center gap_20">
                <div className="mt-1" style={{ width: "100%" }}>
                  <div className="d-flex justify-content-between">
                    <div style={{ display: "inline-flex" }} className="date-title justify-content-between">
                      <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px" }}>STAFF INFORMATION</h6>
                      <div className="d-flex align-items-center gap-2">
                        {/* <label style={{ fontSize: '10px', color: "purple", textDecoration: "underline" }} className="discharge-screen-label mb-0 ">SEE MORE </label> */}
                        <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{userFullName(data?.record?.reportsPreflightTeacher)}</p>
                      </div>
                    </div>
                    {/* <SeeMore title='SEE MORE' /> */}
                  </div>
                  <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-5">
                      <div>
                        <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>DATE OF BIRTH</h5>
                        <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{staffDetails?.createdAt ? moment(staffDetails?.createdAt).format("DD/MM/YYYY") : "--"}</p>
                      </div>
                      <div>
                        <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>EMAIL</h5>
                        <p className="mb-0 proxima_light text-capitalize" style={{ fontSize: "14px", color: "#000" }}>{staffDetails?.email || "--"}</p>
                      </div>
                      <div>
                        <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>PHONE</h5>
                        <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{staffDetails?.phone || "--"}</p>
                      </div>
                    </div>

                    {/* <div className="d-flex align-items-center gap-4">
                      <div>
                        <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>GRADE</h5>
                        <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{data?.client_detail?.grade || "--"}</p>
                      </div>
                      <div>
                        <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>AGE</h5>
                        <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{staffDetails?.createdAt ? getAge(staffDetails?.createdAt) : "--"}</p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="d-flex pt-3 align-items-center gap_20">
                <div className="mt-1" style={{ width: "100%" }}>
                  <div className="date-title d-flex justify-content-between">
                    <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>MORE INFORMATION</h6>
                  </div>
                  <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-5">
                      <div>
                        <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>DATE CREATED</h5>
                        <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{staffDetails?.createdAt ? moment(staffDetails?.createdAt).format("DD/MM/YYYY") : "--"}</p>
                      </div>
                      <div>
                        <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>CLIENT TYPE</h5>
                        <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{staffDetails?.staffDetail?.client_type == "home_education" ? "Home Education" : "School"}</p>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-4">
                      {/* <div>
                                        <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CLASS ID</h5>
                                        <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{data?.client_detail?.grade || "--"}</p>
                                      </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center gap_20">
                <div className="mt-1" style={{ width: "100%" }}>
                  {
                    staffDetails?.client_detail?.client_guardian_mapping?.map((item, index) => index <= 1 && <>
                      <div className="date-title d-flex justify-content-between pt-3">
                        <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>{index == 0 ? "TEACHER" : "COORDINATOR"}</h6>
                      </div>
                      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-5">
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>LAST NAME</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.lastname || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>FIRST NAME</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.firstname || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>EMAIL</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.email || "--"}</p>
                          </div>
                        </div>
                      </div>
                    </>)
                  }
                </div>
              </div>

            </div>
            <Container>
              {
                staffDetails?.staffDetail?.client_type != "home_education" &&
                <Row>
                  <Col>
                    <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                      <section
                        className={`position-relative ClientDetail`}
                      >
                        <div className="" style={{ paddingLeft: '12px', borderRadius: "4px" }}>
                          <div className="py-3">
                            <h6 className="m-0 themeBlue fw-sbold text-capitalize mb-2">
                              ASSIGNED SCHOOLS
                            </h6>
                            <div className="cardCstm p-2">
                              {
                                assignedSchools?.length > 0 ?
                                  assignedSchools?.map((item) => {
                                    return (
                                      <Row className="mb-4">
                                        <Col xs="6" md='4'>
                                          <label className="themeBlue">School Divisions</label><br />
                                          <p className="m-0 forteen themeBlue pt-2 text-capitalize">{item?.divisionTitle}</p>
                                        </Col>
                                        <Col xs="6" md='4'>
                                          <label className="themeBlue">Schools</label><br />
                                          {
                                            item?.schools?.map((list) => (
                                              <p className="m-0 forteen themeBlue pt-2 text-capitalize">{list?.name}</p>
                                            ))
                                          }
                                        </Col>
                                      </Row>
                                    )
                                  })
                                  : (
                                    <NoRecordFoundV2 />
                                  )}
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </Col>
                </Row>
              }
              {/* <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                <section
                  className={`position-relative ClientDetail`}
                >
                  <div className="" style={{ paddingLeft: '12px', borderRadius: "4px" }}>
                    <Row className="d-flex align-items-center justify-content-between mt-4">
                      <Col lg="4">
                        <h6 className="mb-0 proxima-regular" style={{ fontSize: "14px", marginTop: "3px" }}>ASSOCIATED THERAPIST PROFILES
                        </h6></Col>

                      <Col lg="3">
                        <div className="w-100 align-items-center gap-2 reports-v2 classroom-conslutation">
                          <label className="discharge-screen-label mb-0">Search</label>
                          <input
                            onChange={(e) => handleTherapistSearchChange(e.target.value)}
                            className={`input-new readonly-box h-auto search-input-filter-v2`}
                            placeholder="Find a therapist..."
                            defaultValue={therapistFilter?.search}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-between align-items-center" >
                      <Col lg="12">
                        <div className="py-2">
                          <div className="row">
                            <div className="my-2 col-lg-12">
                              <div className="table-outer">
                                {therapistsListLoading ? (
                                  <div style={{ height: "200px" }}>
                                    <LoadingIndicator />
                                  </div>
                                ) : therapistListError ? (
                                  <ErrorComponent />
                                ) : (
                                  <>
                                    {(therapistsListFetching) && (
                                      <LoadingOverlay />
                                    )}
                                    <TableLayoutV2
                                      height={'300px'}
                                      data={therapistsList?.records}
                                      column={therapistColumn}
                                    />
                                    <CstmPagination
                                      className={'paginationV2'}
                                      totalPages={therapistsTotalPages}
                                      activePage={therapistFilter?.page}
                                      handlePageChange={handleTherapistsPageChange}
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </section>
              </div> */}

              {
                staffDetails?.staffDetail?.client_type != "school" &&
                <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                  <section className={`position-relative ClientDetail`}>
                    <div className="" style={{ paddingLeft: '12px', borderRadius: "4px" }}></div>
                    <Row className="d-flex align-items-center justify-content-between mt-4">
                      <Col lg="4">
                        <h6 className="mb-0 proxima-regular" style={{ fontSize: "14px", marginTop: "3px" }}>ASSOCIATED CLIENT PROFILES
                        </h6></Col>

                      <Col lg="3">
                        <div className="w-100 align-items-center gap-2 reports-v2 classroom-conslutation">
                          <label className="discharge-screen-label mb-0">Search</label>
                          <input
                            onChange={(e) => handleClientSearchChange(e.target.value)}
                            className={`input-new readonly-box h-auto search-input-filter-v2`}
                            placeholder="Find a client..."
                            defaultValue={clientsFilter?.search}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Col lg="12">
                      {/* <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                      <div className="left">
                        <TableHeader
                          hideStatusFilter
                          heading={"Associated Client Profiles"}
                          handleFilterChange={handleClientFilterChange}
                          resetFilter={resetClientFilter}
                          filter={clientsFilter}
                          searchPlaceholder="First, Last Name"
                        />
                      </div>
                    </div> */}
                      <div className="table-outer">
                        {clientsListLoading ? (
                          <div style={{ height: "200px" }}>
                            <LoadingIndicator />
                          </div>
                        ) : clientListError ? (
                          <ErrorComponent />
                        ) : (
                          <>
                            {(clientsListFetching) && (
                              <LoadingOverlay />
                            )}
                            <TableLayoutV2
                              noDataMessage={'The therapist has not assigned any clients yet.'}
                              data={clientsList?.records}
                              column={column}
                              height={'300px'}
                            // url={"/manage-support-staff/details"}
                            // filter={filter}
                            // handleSort={handleFilterChange("sort")}
                            />
                          </>
                        )}
                        <CstmPagination
                          className={'paginationV2'}
                          totalPages={clientsTotalPages}
                          activePage={clientCurrentPage}
                          handlePageChange={handleClientPageChange}
                        />
                      </div>
                    </Col>
                  </section>
                </div>
              }
            </Container>

            {/* <Col lg="12" className="my-3">
              <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                    <li className="">
                      <Link
                        className="themeBlue fw-sbold back-to-btn"
                        to={MANAGE_SUPPORT_STAFF_LIST}
                      >
                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                        </svg> Back
                      </Link>
                    </li>
                    <li className="">
                      <Link
                        className="themeBlue fw-sbold"
                        style={{ textDecoration: "underline" }}
                        to={MANAGE_SUPPORT_STAFF_LIST}
                      >
                        Support Staff Profiles
                      </Link>
                    </li>
                    <li className="">
                      <h5 className="m-0 fw-bold themeBlue">
                        /  Details
                      </h5>
                    </li>
                  </ul>
                </div>Associated Groups
              </div>
            </Col> */}
            {/* <Col lg="6" className=" border-end">
              <div className="py-3">
                <div className="top d-flex align-items-center justify-content-between gap-10">
                  <div className="d-flex align-items-center gap-10">
                    <div
                      className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                      style={{ height: 35, width: 35, background: "rgb(219, 219, 219)" }}
                    >
                      {staffDetails?.firstname[0]?.toUpperCase() + staffDetails?.lastname[0]?.toUpperCase()}
                    </div>
                    <div className="content">
                      <h6 className="m-0 themeBlue fw-sbold">{userFullName(staffDetails)}</h6>
                    </div>
                  </div>
                  <div className="right">
                    <div className="d-flex align-items-center gap-10">
                      <h6 className="m-0 themeBlue fw-bold">Status</h6>
                      <Form.Select

                        disabled={updateLoading}
                        style={{ height: "35px" }}
                        className="form-control"
                        aria-label="Default select example"
                        value={statusOptions?.find(x => x.value === staffDetails?.status)?.value}
                        onChange={e => {

                          setStaffUpdateDetails({ status: e.target.value });
                          setShowModal(true);
                        }}
                      >
                        {
                          statusOptions?.map((item, index) => {
                            return <option key={index} value={item.value}>{item?.label}</option>
                          })
                        }
                      </Form.Select>
                    </div>
                  </div>
                </div>

              </div>
              <div className="py-3">
                <Row>
                  <Col lg="4" md="4" sm="6" className="my-2">
                    <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                      <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                        {" "}
                        <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                          ■
                        </span>{" "}
                        Last Name
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2">{staffDetails?.lastname || "--"}</p>
                    </div>
                  </Col>
                  <Col lg="4" md="4" sm="6" className="my-2">
                    <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                      <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                        {" "}
                        <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                          ■
                        </span>{" "}
                        First Name
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2">{staffDetails?.firstname || "--"}</p>
                    </div>
                  </Col>
                  <Col lg="4" md="4" sm="6" className="my-2">
                    <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                      <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                        {" "}
                        <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                          ■
                        </span>{" "}
                        Email
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2">{staffDetails?.email}</p>
                    </div>
                  </Col>
                  <Col lg="4" md="4" sm="6" className="my-2">
                    <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                      <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                        {" "}
                        <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                          ■
                        </span>{" "}
                        Phone
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2">{staffDetails?.phone || "--"}</p>
                    </div>
                  </Col>
                  <Col lg="4" md="4" sm="6" className="my-2">
                    <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                      <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                        {" "}
                        <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                          ■
                        </span>{" "}
                        Date Created
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2">{moment(staffDetails?.createdAt).format("DD/MM/YYYY hh:mm A")}</p>
                    </div>
                  </Col>
                  <Col lg="4" md="4" sm="6" className="my-2">
                    <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                      <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                        {" "}
                        <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                          ■
                        </span>{" "}
                        Client Type
                      </h6>
                      <p className="m-0 forteen themeBlue pt-2">{staffDetails?.staffDetail?.client_type == "home_education" ? "Home Education" : "School"}</p>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="py-3">
                <Row>
                </Row>
              </div>
            </Col> */}
            {/* <div className=" col-lg-6">
              <div className="py-2">
                <div className="row">
                  <div className="my-2 col-lg-12">
                    <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                      <div className="left" style={{ width: "calc(80% - 10px" }}>
                        <TableHeader
                          hideStatusFilter
                          heading={"Associated Therapist Profiles"}
                          handleFilterChange={handleTherapistFilterChange}
                          resetFilter={resetTherapistFilter}
                          filter={therapistFilter}
                          searchPlaceholder="First, Last Name"
                        />
                      </div>
                    </div>
                    <div className="table-outer">
                      {therapistsListLoading ? (
                        <div style={{ height: "200px" }}>
                          <LoadingIndicator />
                        </div>
                      ) : therapistListError ? (
                        <ErrorComponent />
                      ) : (
                        <>
                          {(therapistsListFetching) && (
                            <LoadingOverlay />
                          )}
                          <TableLayoutV2
                            data={therapistsList?.records}
                            column={therapistColumn}
                          // url={"/manage-support-staff/details"}
                          // filter={filter}
                          // handleSort={handleFilterChange("sort")}
                          />
                        </>
                      )}
                      <CstmPagination
                        totalPages={therapistsTotalPages}
                        activePage={therapistFilter?.page}
                        handlePageChange={handleTherapistsPageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </Row>

          {/* {
            staffDetails?.staffDetail?.client_type != "home_education" &&
            <Row>
              <Col>
                <div className="py-3">
                  <h6 className="m-0 themeBlue fw-sbold text-capitalize mb-2">
                    Assigned Schools
                  </h6>
                  <div className="cardCstm p-3 bg-white shadow rounded">
                    {
                      assignedSchools?.length > 0 ?
                        assignedSchools?.map((item) => {
                          return (
                            <Row className="mb-4">
                              <Col xs="6" md='4'>
                                <label className="themeBlue">School Divisions</label><br />
                                <p className="m-0 forteen themeBlue pt-2 text-capitalize">{item?.divisionTitle}</p>
                              </Col>
                              <Col xs="6" md='4'>
                                <label className="themeBlue">Schools</label><br />
                                {
                                  item?.schools?.map((list) => (
                                    <p className="m-0 forteen themeBlue pt-2 text-capitalize">{list?.name}</p>
                                  ))
                                }
                              </Col>
                            </Row>
                          )
                        })
                        : (
                          <NoRecordFoundV2 />
                        )}
                  </div>
                </div>
              </Col>
            </Row>
          } */}

          {/* <Row>
            <Col lg="12">
              <div className="py-3">
                <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                  <div className="left">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                      <li className="">
                      </li>
                    </ul>
                  </div>
                  <div className="right">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                      <li className="">
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                  <div className="left">
                    <TableHeader
                      hideStatusFilter
                      heading={"Associated Client Profiles"}
                      handleFilterChange={handleClientFilterChange}
                      resetFilter={resetClientFilter}
                      filter={clientsFilter}
                      searchPlaceholder="First, Last Name"
                    />
                  </div>
                </div>
                <div className="table-outer">
                  {clientsListLoading ? (
                    <div style={{ height: "200px" }}>
                      <LoadingIndicator />
                    </div>
                  ) : clientListError ? (
                    <ErrorComponent />
                  ) : (
                    <>
                      {(clientsListFetching) && (
                        <LoadingOverlay />
                      )}
                      <TableLayoutV2
                        noDataMessage={'The therapist has not assigned any clients yet.'}
                        data={clientsList?.records}
                        column={column}
                      // url={"/manage-support-staff/details"}
                      // filter={filter}
                      // handleSort={handleFilterChange("sort")}
                      />
                    </>
                  )}
                  <CstmPagination
                    totalPages={clientsTotalPages}
                    activePage={clientCurrentPage}
                    handlePageChange={handleClientPageChange}
                  />
                </div>
              </div>
            </Col>
          </Row> */}
        </Container>
        }
      </section>
    </>
  );
};

export default SupportStaffDetails;
